import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonImg } from "@ionic/react";
import { Trans, useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import requestAssigned from "../../../../assets/image/truckAssigned.png";
import requestFinished from "../../../../assets/image/truckFinished.png";
import requestPending from "../../../../assets/image/truckPending.png";
import requestPreparedAssigned from "../../../../assets/image/truckPreparedAssigned.png";
import { AppRoutes } from "../../../../constants/appRoutes";
import { RequestStates } from "../../../../constants/requestStates";
import "./itemStyle.css";
import { RequestListItemStyle } from "./itemStyle.jss";

export interface IRequestItem {
    stateDescription: string;
    id: number;
    date: string;
    transportUnitNumber: string;
    dockCode: string;
    dockDescription: string;
    stateSort: number;
}

interface IRequestListItemProps {
    request: IRequestItem;
}

const RequestListItem: React.FC<IRequestListItemProps> = ({ request }) => {
    const { t } = useTranslation("common");
    const theme = useTheme();
    const style = RequestListItemStyle({ theme });
    const { dockDescription, transportUnitNumber, id, stateSort, dockCode } = request;
    const stateImage = () => {
        if (stateSort === RequestStates.PREPARED && dockCode) {
            return requestPreparedAssigned;
        } else if (stateSort === RequestStates.PREPARED || stateSort === RequestStates.PREPARED_DOCK || stateSort === RequestStates.PRESENTED) {
            return requestAssigned;
        } else if (stateSort === RequestStates.DOCK) {
            return requestPending;
        } else {
            return requestFinished;
        }
    };

    const colorTextWithState = () => {
        if (stateSort === RequestStates.PREPARED && dockCode) {
            return style.requestPreparedAssigned;
        } else if (stateSort === RequestStates.PREPARED || stateSort === RequestStates.PREPARED_DOCK || stateSort === RequestStates.PRESENTED) {
            return style.requestPending;
        } else if (stateSort === RequestStates.DOCK) {
            return style.requestAssigned;
        } else {
            return style.requestFinished;
        }
    };

    const colorBorderCardWithState = () => {
        if (stateSort === RequestStates.PREPARED && dockCode) {
            return "ionCardContainerPeparedAndAssigned";
        } else if (stateSort === RequestStates.PREPARED || stateSort === RequestStates.PREPARED_DOCK || stateSort === RequestStates.PRESENTED) {
            return "ionCardContainerPending";
        } else if (stateSort === RequestStates.DOCK) {
            return "ionCardContainerAssigned";
        } else {
            return "ionCardContainerFinished";
        }
    };

    const RequestStateTitleCard = () => {
        if (stateSort === RequestStates.PREPARED && dockCode) {
            return t("PAGE.REQUEST.TITLE_STATE.PREPARED_AND_ASSINGNED");
        } else if (stateSort === RequestStates.PREPARED || stateSort === RequestStates.PRESENTED) {
            return t("PAGE.REQUEST.TITLE_STATE.PREPARED");
        } else if (stateSort === RequestStates.PREPARED_DOCK) {
            return t("PAGE.REQUEST.TITLE_STATE.PREPARED_DOCK");
        } else if (stateSort === RequestStates.DOCK) {
            return t("PAGE.REQUEST.TITLE_STATE.DOCK");
        } else {
            return t("PAGE.REQUEST.TITLE_STATE.EXIT_DOCK");
        }
    };
    const RequestStateDescriptionCard = () => {
        switch (stateSort) {
            case RequestStates.PREPARED:
                if (dockCode) return "PAGE.REQUEST.DESCRIPTION_STATE.PREPARED_ASSIGNED";
                return "PAGE.REQUEST.DESCRIPTION_STATE.PREPARED";
            case RequestStates.PRESENTED:
                return "PAGE.REQUEST.DESCRIPTION_STATE.PREPARED";
            case RequestStates.PREPARED_DOCK:
                return "PAGE.REQUEST.DESCRIPTION_STATE.PREPARED";
            case RequestStates.DOCK:
                return "PAGE.REQUEST.DESCRIPTION_STATE.DOCK";
            case RequestStates.DOCK_END:
                return "PAGE.REQUEST.DESCRIPTION_STATE.DOCK";
            default:
                return "PAGE.REQUEST.DESCRIPTION_STATE.EXIT_DOCK";
        }
    };
    const RequestStateValuesCard = () => {
        switch (stateSort) {
            case RequestStates.PREPARED:
                if (dockCode) return { transportUnitNumber: transportUnitNumber, dock: dockDescription };
                return { transportUnitNumber: transportUnitNumber };
            case RequestStates.PRESENTED:
                return { transportUnitNumber: transportUnitNumber };
            case RequestStates.PREPARED_DOCK:
                return { transportUnitNumber: transportUnitNumber, dock: dockDescription };
            case RequestStates.DOCK:
                return { transportUnitNumber: transportUnitNumber };
            case RequestStates.DOCK_END:
                return { transportUnitNumber: transportUnitNumber };
            default:
                return { transportUnitNumber: transportUnitNumber };
        }
    };

    return (
        <div className={style.container}>
            <IonCard
                className={colorBorderCardWithState()}
                color={"light"}
                routerLink={AppRoutes.REQUEST_DETAILS.replace(":id", String(id))}
                routerDirection="forward"
            >
                <IonCardHeader>
                    <IonCardTitle>
                        <span className={colorTextWithState()}>{RequestStateTitleCard().toUpperCase()}</span>
                    </IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                    <div className={style.containerData}>
                        <span className={style.text}>
                            <Trans
                                i18nKey={RequestStateDescriptionCard()}
                                values={RequestStateValuesCard()}
                            />
                        </span>
                        <IonImg
                            className={style.image}
                            src={stateImage()}
                        />
                    </div>
                </IonCardContent>
            </IonCard>
        </div>
    );
};

export default RequestListItem;
